export class Constants {
    public static readonly PENDENTE = "Pendente";
    public static readonly FALTANTE = "Faltante";
    public static readonly RO= "RO";
    public static readonly PO= "PO";
    public static readonly OEC= "OEC";
}